export const TRUSTPILOT_RATING_QUERY_KEY = 'TRUSTPILOT_RATING_QUERY_KEY';
